import { render } from "./ConfigContainer.vue?vue&type=template&id=156de8ae"
import script from "./ConfigContainer.vue?vue&type=script&lang=js"
export * from "./ConfigContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__